import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    ViewChild
} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-content-section",
    styleUrls: ["./content-section.component.scss"],
    templateUrl: "./content-section.component.html",
    standalone: false
})
export class FUIContentSectionComponent {
    private _content: ElementRef;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    @HostBinding("class.filled") public filled: boolean;
    @Input() @HostBinding("class.sticky") public sticky: boolean;

    @ViewChild("content")
    set content(value: ElementRef) {
        this._content = value;
        setTimeout(() => {
            this.filled = this._content && this._content.nativeElement && this._content.nativeElement.children.length;
            this.changeDetectorRef.markForCheck();
        });
    }

    get content(): ElementRef {
        return this._content;
    }
}
